import { type Tournament } from '@clubspark-node/clubspark-tennis-types';

import { TournamentCompletionStatus, type TournamentListItemInterface } from 'typedefs/tournamentTypes';

export const getMockTournamentListingFromTournamentRecord = (tournament: Tournament) => {
  const entriesCloseDateTime = new Date(tournament.startDate);
  const timeZone = 'America/New_York';

  const dateNoTime = (dateString) => {
    if (dateString) return `${new Date(dateString).toISOString().split('T')[0]}T00:00:00.000Z`;
  };

  return {
    identificationCode: tournament.tournamentId,
    id: tournament.tournamentId,
    timings: {
      startDate: tournament.startDate,
      endDate: tournament.endDate,
      startDateTime: dateNoTime(tournament.startDate),
      endDateTime: dateNoTime(tournament.endDate),
      timeZone,
    },
    name: tournament.tournamentName,
    level: { id: null, name: 'Demo' },
    approvedEventCount: tournament.events?.length,
    uniqueRegistrationsCount: tournament.participants.length,
    primaryLocation: { name: tournament.venues?.[0]?.venueName ?? '' },
    registrationRestrictions: {
      entriesOpenDateTime: new Date(tournament.startDate),
      entriesCloseDateTime,
      timeZone,
    },
    websiteContent: {
      logoPath: '',
    },
    organisation: {
      id: null,
      urlSegment: null,
    },
  };
};

export const mockFilterData = ({ items, status }): { items: TournamentListItemInterface[]; totalItems: number } => {
  let filteredItems = items ?? [];

  if (status === TournamentCompletionStatus.COMPLETED) {
    filteredItems = filteredItems.filter((d) => new Date(d.timings.endDate).getTime() < new Date().getTime());
  } else if (status === TournamentCompletionStatus.ACTIVE) {
    filteredItems = filteredItems.filter((d) => new Date(d.timings.endDate).getTime() >= new Date().getTime());
  }

  const totalItems = filteredItems.length;

  return {
    items: filteredItems,
    totalItems,
  };
};
